import { useState } from "react"
import { ChakraProvider, ColorModeScript } from "@chakra-ui/react"
import "@fontsource/lato"
import "@fontsource/open-sans"

import {
    AppContainer,
    GetValueForm,
    Grid,
    ResponseDetail,
    ResponseHistory,
    SaveValueForm,
} from "@/components"
import { FullScreenProvider } from "@/providers"
import { theme } from "@/theme"
import {ApiCallForm} from "./components/api-call-form";

function App() {
    const [response, setResponse] = useState()
    const [changeMode, setChangeMode] = useState(false)

    return (
        <>
            <ColorModeScript initialColorMode={theme.config.initialColorMode} />
            <FullScreenProvider>
                <ChakraProvider theme={theme}>
                    <AppContainer setChangeMode={setChangeMode}>
                        <Grid columns={3} rows={3}>
                            {!changeMode ? (
                                <>
                                    <SaveValueForm
                                        title="Store Value to DB"
                                        colSpan={{ base: 1, lg: 1 }}
                                        rowSpan={1}
                                        setResponse={setResponse}
                                    />
                                    <GetValueForm
                                        title="Get Value from DB or Cache"
                                        colSpan={{ base: 1, lg: 1 }}
                                        rowSpan={1}
                                        setResponse={setResponse}
                                    />
                                </>
                            ) : (
                                <ApiCallForm
                                    title="Call third party API"
                                    colSpan={{ base: 1, lg: 2 }}
                                    rowSpan={1}
                                    setResponse={setResponse}
                                />
                            )}
                            <ResponseDetail
                                title="Response"
                                colSpan={{ base: 1, lg: 1 }}
                                rowSpan={3}
                                response={response}
                            />
                            <ResponseHistory
                                title="Request History"
                                colSpan={{ base: 1, lg: 2 }}
                                rowSpan={2}
                                response={response}
                            />
                        </Grid>
                    </AppContainer>
                </ChakraProvider>
            </FullScreenProvider>
        </>
    )
}

export default App
